import { useEffect, useRef, useState } from 'react';

// Scroll-reveal hook using IntersectionObserver.
// Returns [ref, visible].
// Options: `initial` (start visible — used for above-the-fold LCP content that
// must paint on the first frame instead of waiting for an IO callback).
export function useReveal(options = {}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(!!options.initial);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px', ...options }
    );

    observer.observe(node);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [ref, visible];
}
